import { useState } from 'react'
import { TABS } from './constants'
import Masthead from './Masthead'
import MarketOverview from './MarketOverview'
import InstitutionAnalysis from './InstitutionAnalysis'
import MechanicsLab from './MechanicsLab'
import RiskLab from './RiskLab'
import ResearchVault from './ResearchVault'
import { colors, fonts } from './theme'

export default function App() {
  const [activeTab, setActiveTab] = useState(TABS.MARKET)

  return (
    <div style={styles.app}>
      <Masthead activeTab={activeTab} onTabChange={setActiveTab} />

      <main style={styles.main}>
        {activeTab === TABS.MARKET && <MarketOverview />}
        {activeTab === TABS.INSTITUTIONS && <InstitutionAnalysis />}
        {activeTab === TABS.MECHANICS && <MechanicsLab />}
        {activeTab === TABS.RISK_LAB && <RiskLab />}
        {activeTab === TABS.RESEARCH && <ResearchVault />}
      </main>

      <footer style={styles.footer}>
        <span style={styles.footerText}>Markov Agents — Private Credit Intelligence</span>
        <span style={styles.footerText}>Lori + Dave</span>
      </footer>
    </div>
  )
}

const styles = {
  app: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    background: colors.navy,
  },
  main: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px 32px',
    borderTop: `1px solid ${colors.rule}`,
    background: colors.navyDeep,
  },
  footerText: {
    fontFamily: fonts.mono,
    fontSize: 11,
    color: colors.textMuted,
  },
}
